import PreviewElement from '../PreviewElement';

export default class PictureElement extends PreviewElement {
  injectSessionData(page): void {
    // check if the area already exists
    let areaExist = page.pictures.find((area) => {
      return area.areaName === this.element.content.areaTypeName;
    });

    // if it exists then update the text otherwise add a new area
    if (areaExist) {
      areaExist.url = this.element.content.content.image;
    } else {
      page.pictures.push({
        areaName: this.element.content.areaTypeName,
        url: this.element.content.content.image
      });
    }
  }
}
